import { RENAMED_GOALS } from 'src/constants/goals';
import { ColumnCell, ColumnHeader } from './Components';

export const GoalColumn = {
  key: 'goal',
  header: () => <ColumnHeader className="w-48">Goal</ColumnHeader>,
  cell: ({ campaign }) => <ColumnCell className="capitalize">{RENAMED_GOALS[campaign.goal]}</ColumnCell>,
};
